<div class="flex flex-col h-full bg-gray-950 rounded-lg overflow-hidden border border-gray-700">

  <!-- Title bar -->
  <div class="flex items-center justify-between px-3 py-2 bg-gray-900 border-b border-gray-700">
    <div class="flex items-center gap-2">
      <span class="text-xs font-mono text-gray-400">terminal</span>
      <span class="text-xs font-mono text-gray-600">—</span>
      <span class="text-xs font-mono text-gray-500">{{ clientId }}</span>
    </div>
    <div class="flex items-center gap-2">
      @if (isConnected && !hasError) {
        <span class="flex items-center gap-1 text-xs text-green-400">
          <span class="inline-block w-1.5 h-1.5 rounded-full bg-green-400"></span>
          connected
        </span>
      } @else if (hasError) {
        <span class="flex items-center gap-1 text-xs text-red-400">
          <span class="inline-block w-1.5 h-1.5 rounded-full bg-red-400"></span>
          disconnected
        </span>
        <button
          (click)="reconnect()"
          class="text-xs text-gray-400 hover:text-white transition-colors px-2 py-0.5 border border-gray-600 rounded">
          Reconnect
        </button>
      } @else {
        <span class="flex items-center gap-1 text-xs text-yellow-400">
          <span class="animate-pulse inline-block w-1.5 h-1.5 rounded-full bg-yellow-400"></span>
          connecting...
        </span>
      }
    </div>
  </div>

  <!-- Output -->
  <div
    #outputEl
    class="flex-1 overflow-y-auto px-3 py-2 font-mono text-xs text-green-300 leading-relaxed min-h-0">
    @for (line of lines; track $index) {
      @if (line.isHtml) {
        <div class="terminal-html my-1" [innerHTML]="line.content"></div>
      } @else {
        <div class="whitespace-pre-wrap break-all"
             [class.text-gray-400]="line.content.startsWith('$')"
             [class.text-red-400]="line.content.startsWith('[error')">{{ line.content }}</div>
      }
    }
    @if (lines.length === 0) {
      <div class="text-gray-600 italic">Waiting for output...</div>
    }
  </div>

  <!-- Input -->
  <div class="flex items-center gap-2 px-3 py-2 border-t border-gray-700 bg-gray-900">
    <span class="text-green-400 font-mono text-xs select-none">$</span>
    <input
      type="text"
      [(ngModel)]="currentInput"
      (keydown.enter)="sendCommand()"
      [disabled]="!isConnected"
      placeholder="Enter command..."
      class="flex-1 bg-transparent text-green-300 font-mono text-xs outline-none placeholder-gray-600 disabled:opacity-40"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
    />
    <button
      (click)="sendCommand()"
      [disabled]="!isConnected || !currentInput.trim()"
      class="text-xs text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors font-mono">
      ↵
    </button>
  </div>

</div>
